import { Component, OnInit } from '@angular/core';
import { VelicinaSet } from './velicina-set';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-velicina-set-update',
  templateUrl: './velicina-set-update.component.html'
})
export class VelicinaSetUpdateComponent
 extends BaseUpdateComponent<VelicinaSet>
  implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    // this.addValidatorToFc("Naziv", Validators.required, 'required', 'VRSTADOKUMENTA.NAZIV.VALIDATION.REQUIRED');
    // this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'VRSTADOKUMENTA.NAZIV.VALIDATION.MAXLENGTH');
    // this.addValidatorToFc("GenericName", Validators.maxLength(10), 'maxlength', 'VRSTADOKUMENTA.GENERICNAME.VALIDATION.MAXLENGTH');

  }

}
